import React from "react";

import ContactForm from "components/ContactForm";

const FormBlock = ({ node }) => <ContactForm {...node.form} />;

export default FormBlock;
